import { render, staticRenderFns } from "./m-special-plank-table.vue?vue&type=template&id=46481e4a&scoped=true&"
import script from "./m-special-plank-table.vue?vue&type=script&setup=true&lang=ts&"
export * from "./m-special-plank-table.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./m-special-plank-table.vue?vue&type=style&index=0&id=46481e4a&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46481e4a",
  null
  
)

export default component.exports